'use strict';
import { GetAppData } from '../core/core';
let app = GetAppData();

/**
 * Mobile端，用于M站，RN页等
 * @type {{Url: string, Domain: string}}
 */
export const M = {
  Url: 'https://m.xiaomiyoupin.com',
  Domain: 'm.xiaomiyoupin.com',
  SubDomain: 'm.xiaomiyoupin.com',
  StDomain: 'http://st.m.xiaomiyoupin.com',
  TradeStDomain: 'https://trade.m.st.xiaomiyoupin.com',
  tradeUrl: 'https://trade.m.xiaomiyoupin.com',
};

let host = M.Url;
if (app) {
  //如果是pc端或者m站端 就用当前域名 不做更换
  if (app.isInPc() || app.isInM()) {
    host = app.isStagingMode() ? app.getHost().devHost : app.getHost().host;
  }
} else {
}

/**
 * 静态资源前缀地址
 * @type {{Image: string, File: string}}
 */
export const Resource = {
  Image: 'https://m.xiaomiyoupin.com/app/shop/img',
  File: 'https://m.xiaomiyoupin.com/app/shop/file',
};

/**
 * 业务型独立页面地址
 */
export const Activity = {
  Base: `${host}/app/shop/content`, // 活动页基础地址
  ContentPath: 'https://m.xiaomiyoupin.com/content',
  Static: 'https://m.xiaomiyoupin.com/app/shop/content',
  SecKillPath: 'https://m.xiaomiyoupin.com/r/secbuy?type=secbuy',
};

const validSubHosts = ['.youpin.mi.com', '.home.mi.com', '.xiaomiyoupin.com', '.youpin.cn', '.youpin.com.cn'];

String.prototype.right = function (len) {
  if (isNaN(len) || len == null) {
    len = this.length;
  } else {
    if (parseInt(len) < 0 || parseInt(len) > this.length) {
      len = this.length;
    }
  }

  return this.substring(this.length - len, this.length);
};

/**
 * 是否为有效的我品HOST（兼容旧版米家和有品自己顶级域名）
 * @param hostName
 * @returns {boolean}
 */
export const isValidHost = (hostName) => {
  if (!hostName) return false;
  //一级域名判断
  if (
    hostName == 'youpin.mi.com' ||
    hostName == 'home.mi.com' ||
    hostName == 'xiaomiyoupin.com' ||
    hostName == 'youpin.cn'
  ) {
    return true;
  }
  //二级域名判断
  for (let i = 0; i < validSubHosts.length; i++) {
    let mainDomain = hostName.right(validSubHosts[i].length);
    if (mainDomain == validSubHosts[i]) {
      return true;
    }
  }

  return false;
};

/**
 * 是否是品位页HOST
 * @param hostName
 * @returns {*|boolean}
 */
export const isValidPinWeiHost = (hostName, path) => {
  if (!isValidHost(hostName)) {
    return false;
  }
  return path && path.indexOf('/app/shop/content?aid=') >= 0;
};

/**
 * 获取活动域名
 * @param hostName
 * @returns {*|boolean}
 */
export const getActivityBase = () => {
  let app = GetAppData();
  let host = M.Url;
  if (app) {
    //如果是pc端或者m站端 就用当前域名 不做更换
    if (app.isInPc() || app.isInM()) {
      host = app.isStagingMode() ? app.getHost().devHost : app.getHost().host;
    }
  }
  let base = `${host}/app/shop/content`; // 活动页基础地址
  return base;
};

/**
 * 获取当前接口域名
 * @param hostName
 * @returns {*|boolean}
 */
export const getCurrentHost = () => {
  let app = GetAppData();
  let host = 'https://m.xiaomiyoupin.com'; // 默认接口域名
  if (app) {
    //如果是pc端或者m站端 就用当前域名 不做更换
    host = app.isStagingMode() ? app.getHost().devHost : app.getHost().host;
  }
  return host;
};
